/**
 * Получить дату без времени
 * @returns Date
 */
Date.prototype.getDateWithoutTime = function () {
  return new Date(this.toDateString())
}

/**
 * Получить объект из localStorage
 * @param {String} key  Ключ в localStorage
 * @returns Объект
 */
Storage.prototype.getObject = function(key) {
  var value = this.getItem(key)
  if (!value) { return }
  try {
    return JSON.parse(value)
  } catch (error) {
    return {}
  }
}